import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import React from 'react';
import { StyledCellFormatter } from '../StyledCellWrapper';
import { AlertIconWithUber } from '../../../../extract/components/AlertInfo';

export interface IAlert {
  type: string;
}

export function AlertCell(alertFn: (row: DataGrid.Row) => IAlert): React.StatelessComponent<BodyCell.Props> {
  return StyledCellFormatter(
      function AlertIconWithUberPopup(props: BodyCell.Props): JSX.Element {
        const {row} = props;
        const alert = alertFn(row);
        const id = row.data['id'];
        const hasAlert = row.data['hasAlert'];

        return <>
          {hasAlert &&
          <AlertIconWithUber
              iconButtonStyle={{cursor: 'pointer', margin: '2px', verticalAlign: 'middle'}}
              id={id}
              tabindex={-1}
              type={alert.type}
          />}
        </>;
      }
  );
}
